var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gotop-button",attrs:{"title":"Scroll back to the top of the page"},on:{"click":_vm.scrollTop}},[_c('font-awesome-icon',{staticClass:"gotop-icon",attrs:{"icon":"chevron-up"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }